import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
//import {getBallotTypes, getVoters} from '../services/api'
import entitiesData from '../data/entities.json'; // Import the JSON file
import '../styles/Navbar.css';

const Navbar = () => {
  const [entities, setEntities] = useState([]);
  //const [selectedEntity, setSelectedEntity] = useState('');
  const navigate = useNavigate();

  // Load entities from the imported JSON data
  useEffect(() => {
    setEntities(entitiesData.entities);
  }, []);

  // Handle dropdown selection
  const handleEntityChange = (event) => {
    const selectedPath = event.target.value;
    //setSelectedEntity(selectedPath);
    navigate(selectedPath); // Navigate to the selected entity's path
  };
//<a href="https://github.com/CodeBusters-Wordle-Crackdown/Team-Code-Busters-2.0/" target="_blank" rel="noopener noreferrer">Team Code Busters </a>
  return (
    <nav>
          <div style={{display: 'flex'}}>
            <h1>
                <a href="https://www.ballotvision.com" target="_blank" rel="noopener noreferrer">
                    BallotVision
                </a>
            </h1>
            <div style={{marginLeft: '16px', marginTop: '16px'}}>
              <img src="./logo192.png" width="48" height="48" alt="Logo"/>
            </div>
          </div>

      <div className="nav-controls">
        {/* <select value={selectedEntity} onChange={handleEntityChange}>
          <option value="">Select an Entity</option>
          {entities.map((entity) => (
            <option key={entity.id} value={entity.path}>
              {entity.name}
            </option>
          ))}
        </select> */}
        <ul>
          <li><Link to="/">Home</Link></li>
          <li><Link to="/summary-data">Summary Results</Link></li>
          <li><Link to="/map">Map</Link></li>
          <li><Link to="/ranked-choice-voting">Ranked Choice Voting</Link></li>
          {/*<li><Link to="/about">About</Link></li>*/
          }
          
        </ul>
      </div>
    </nav>
  );
};

export default Navbar;